import gql from 'gql-tag'
import { BASE_ORGANIZATION_FRAGMENT } from 'fragments/organization.query'

export const GET_ORGANIZATION_LIST = gql`
  query OrganizationList($offset: Int) {
    OrganizationList(_count: 1000, _offset: $offset, _sort: "-_lastUpdated") {
      ...BaseOrganization
    }
  }
  ${BASE_ORGANIZATION_FRAGMENT}
`
